export default __webpack_public_path__ + "static/media/SG-Red-0004.a385a73f.png";